import React from 'react';
import { BookIcon, BrainIcon, PieChartIcon, ShoppingCartIcon, CalendarIcon, CheckCircle2Icon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Modules() {
  const modules = [{
    icon: BrainIcon,
    tomo: 'Tomo 1',
    title: '¿Por Qué Mi Hijo No Entiende Matemáticas?',
    desc: 'Los 5 tipos de bloqueo, diagnóstico del hueco real y el plan de los primeros 30 días.'
  }, {
    icon: BookIcon,
    tomo: 'Tomo 2',
    title: 'Cómo Explicar Matemáticas Sin Ser Profesor',
    desc: 'El protocolo de los 4 pasos, banco de preguntas y el lenguaje que abre el aprendizaje.'
  }, {
    icon: PieChartIcon,
    tomo: 'Tomo 3',
    title: 'Multiplicaciones, Divisiones y Fracciones Sin Estrés',
    desc: 'Métodos visuales para los 3 temas donde más se pierden los niños. Analogías reales paso a paso.'
  }, {
    icon: ShoppingCartIcon,
    tomo: 'Tomo 4',
    title: 'Matemáticas en la Vida Real',
    desc: 'El supermercado, la cocina y el dinero para que practique sin sentir que estudia. 30 actividades.'
  }, {
    icon: CalendarIcon,
    tomo: 'Tomo 5',
    title: '90 Días para Recuperar la Confianza Matemática',
    desc: 'Rutinas diaria, semanal y mensual para convertir lo aprendido en un cambio permanente.'
  }];
  const includes = ['Protocolos listos para imprimir', 'Métodos visuales paso a paso', 'Checklists de verificación', 'Plantillas A4 para usar en la sesión'];
  return <section className="py-12 md:py-16 bg-surfaceLight/30 border-y border-slate-200 relative" data-id="element-214">
      <div className="container mx-auto px-4 relative z-10" data-id="element-215">
        <FadeIn data-id="element-216">
          <div className="text-center mb-8" data-id="element-217">
            <h2 className="font-heading text-2xl md:text-4xl font-extrabold mb-2 text-slate-900" data-id="element-218">
              🏆 MEGAPACK MATEMÁTICAS SIN LÁGRIMAS
            </h2>
            <p className="text-base md:text-lg text-primary-dark font-bold mb-2" data-id="element-219">
              5 Tomos + 3 Bonos — Tablas → Divisiones → Fracciones
            </p>
            <p className="text-slate-600 max-w-2xl mx-auto text-sm md:text-base" data-id="element-220">
              Diversos métodos, protocolos y herramientas. Todo resuelto.
            </p>
          </div>
        </FadeIn>

        {/* Compact, centered card grid */}
        <div className="flex flex-wrap justify-center gap-4 md:gap-5 mb-8 max-w-5xl mx-auto" data-id="element-221">
          {modules.map((mod, i) => {
          const Icon = mod.icon;
          return <FadeIn key={i} delay={i * 0.05} className="w-full sm:w-[calc(50%-0.625rem)] lg:w-[calc(33.333%-0.834rem)]" data-id="element-222">
                <div className="bg-white p-4 md:p-5 rounded-2xl shadow-soft border border-slate-100 hover:shadow-soft-lg transition-all duration-300 group h-full hover:-translate-y-1 flex gap-3 md:gap-4" data-id="element-223">
                  <div className="w-10 h-10 md:w-11 md:h-11 rounded-xl bg-primary/10 flex items-center justify-center shrink-0 group-hover:bg-primary/20 transition-colors" data-id="element-224">
                    <Icon className="w-5 h-5 text-primary-dark" data-id="element-225" />
                  </div>
                  <div className="min-w-0" data-id="element-226">
                    <span className="text-[10px] md:text-[11px] font-extrabold uppercase tracking-widest text-primary-dark" data-id="element-227">
                      {mod.tomo}
                    </span>
                    <h3 className="font-heading text-sm md:text-base font-extrabold mb-1 text-slate-900 leading-tight" data-id="element-228">
                      {mod.title}
                    </h3>
                    <p className="text-slate-600 text-xs md:text-sm leading-snug" data-id="element-229">
                      {mod.desc}
                    </p>
                  </div>
                </div>
              </FadeIn>;
        })}
        </div>

        <FadeIn delay={0.4} data-id="element-230">
          <div className="bg-white p-5 md:p-6 rounded-2xl shadow-soft border border-slate-100 max-w-4xl mx-auto" data-id="element-231">
            <h4 className="text-center font-heading text-lg font-bold text-slate-900 mb-4" data-id="element-232">
              Cada tomo incluye:
            </h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5" data-id="element-233">
              {includes.map((item, i) => <div key={i} className="flex items-center gap-2.5 bg-surfaceLight/50 px-3 py-2.5 rounded-xl" data-id="element-234">
                  <CheckCircle2Icon className="w-4 h-4 text-primary shrink-0" data-id="element-235" />
                  <span className="text-slate-700 font-bold text-xs md:text-sm" data-id="element-236">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}